import { LIVE_CASINO_PATH } from '~/constants'
import { LOBBY_GAME_URLS } from '~/configs/page-url'
import { CATEGORY_GAME_SLUG } from '~/resources/lobby-games/urls'

const globImages: GlobImageI = import.meta.glob('~/assets/images/pages/lobby-games/*', { eager: true })
const iconImgUrl = '/assets/images/pages/lobby-games'

export const menuBarGame = [
  {
    title: 'Nổ Hũ',
    category: CATEGORY_GAME_SLUG.NOHU,
    imgSrc: getImageURL(globImages, 'icon-game-jackpot', iconImgUrl, 'svg'),
    label: 'Hot'
  },
  {
    title: 'Bắn Cá',
    category: CATEGORY_GAME_SLUG.BANCA,
    imgSrc: getImageURL(globImages, 'icon-game-fishing', iconImgUrl, 'svg'),
    label: 'Hot'
  },
  {
    title: 'Game Bài',
    category: CATEGORY_GAME_SLUG.GAME_BAI,
    imgSrc: getImageURL(globImages, 'icon-game-card', iconImgUrl, 'svg'),
    label: 'New'
  },
  {
    title: 'Slots',
    category: CATEGORY_GAME_SLUG.SLOTS,
    imgSrc: getImageURL(globImages, 'icon-game-slots', iconImgUrl, 'svg')
  },
  {
    title: 'Quay Số',
    category: CATEGORY_GAME_SLUG.QUAY_SO,
    imgSrc: getImageURL(globImages, 'icon-game-dial', iconImgUrl, 'svg')
  },
  {
    title: 'Instant Games',
    category: CATEGORY_GAME_SLUG.INSTANT_GAMES,
    imgSrc: getImageURL(globImages, 'icon-game-instant-games', iconImgUrl, 'svg')
  },
  {
    title: 'Battle Games',
    category: CATEGORY_GAME_SLUG.BATTLE_GAMES,
    imgSrc: getImageURL(globImages, 'icon-game-battle', iconImgUrl, 'svg')
  },
  {
    title: 'Ingame',
    category: CATEGORY_GAME_SLUG.INGAME,
    imgSrc: getImageURL(globImages, 'icon-game-ingame', iconImgUrl, 'svg')
  },
  {
    title: 'Lô Đề',
    category: CATEGORY_GAME_SLUG.LODE,
    imgSrc: getImageURL(globImages, 'icon-game-lode', iconImgUrl, 'svg')
  },
  {
    title: 'Game Khác',
    category: CATEGORY_GAME_SLUG.OTHERS,
    imgSrc: getImageURL(globImages, 'icon-game-other', iconImgUrl, 'svg')
  }
]
export const homeCategories = [
  {
    label: 'LIVE CASINO',
    className: 'live-casino',
    text: 'Cược To - Thắng Lớn',
    imgSrc: getImageURL(globImages, 'live_casino', iconImgUrl, 'webp'),
    link: LOBBY_GAME_URLS.CASINO,
    category: CATEGORY_GAME_SLUG.LIVE_CASINO
  },
  {
    label: 'NỔ HŨ',
    className: 'no-hu',
    text: 'Hũ To - Trúng Đậm',
    imgSrc: getImageURL(globImages, 'no_hu', iconImgUrl, 'webp'),
    link: LOBBY_GAME_URLS.NO_HU,
    category: CATEGORY_GAME_SLUG.NOHU
  }
]

export const mainMenuTab = [
  {
    label: 'Nổi Bật',
    link: LOBBY_GAME_URLS.HOME,
    icon: getImageURL(globImages, 'icon-noibat', iconImgUrl, 'webp')
  },
  {
    label: 'Thể Thao',
    link: LOBBY_GAME_URLS.SPORTS,
    icon: getImageURL(globImages, 'icon-the-thao', iconImgUrl, 'webp'),
    subLink: '/the-thao/lich-thi-dau'
  },
  {
    label: 'Live Casino',
    link: LOBBY_GAME_URLS.CASINO,
    icon: getImageURL(globImages, 'icon-live-casino', iconImgUrl, 'webp')
  },
  {
    label: 'Slots, Nổ Hũ',
    link: LOBBY_GAME_URLS.NO_HU,
    icon: getImageURL(globImages, 'icon-nohu', iconImgUrl, 'webp')
  },
  {
    label: 'Game Bài',
    link: LOBBY_GAME_URLS.GAME_BAI,
    icon: getImageURL(globImages, 'icon-game-bai', iconImgUrl, 'webp')
  },
  {
    label: 'Bắn Cá',
    link: LOBBY_GAME_URLS.FISHING,
    icon: getImageURL(globImages, 'icon-banca', iconImgUrl, 'webp')
  },
  {
    label: 'Lô Đề',
    link: LOBBY_GAME_URLS.LODE,
    icon: getImageURL(globImages, 'icon-lode', iconImgUrl, 'webp')
  },
  {
    label: 'Quay Số',
    link: LOBBY_GAME_URLS.LOTTERY,
    icon: getImageURL(globImages, 'icon-quayso', iconImgUrl, 'webp')
  },
  {
    label: 'Game Khác',
    link: LOBBY_GAME_URLS.OTHERS,
    icon: getImageURL(globImages, 'icon-game-khac', iconImgUrl, 'webp')
  }
]

export const menuBarGameMobile = [
  {
    title: 'Nổi Bật',
    url: '/',
    category: '/lobby-game',
    icon: 'icon-ingame',
    label: ''
  },
  {
    title: 'Thể Thao',
    category: '',
    url: '/the-thao',
    icon: 'icon-the-thao',
    label: 'New'
  },
  {
    title: 'Live Casino',
    url: LIVE_CASINO_PATH,
    category: '',
    icon: 'icon-live-casino',
    label: 'Hot'
  },
  {
    title: 'Slots, Nổ Hũ',
    url: LOBBY_GAME_URLS.NO_HU,
    category: CATEGORY_GAME_SLUG.NOHU,
    icon: 'icon-no-hu',
    label: 'Hot'
  },
  {
    title: 'Game Bài',
    url: LOBBY_GAME_URLS.GAME_BAI,
    category: CATEGORY_GAME_SLUG.GAME_BAI,
    icon: 'icon-game-bai',
    label: 'New'
  },
  {
    title: 'Bắn Cá',
    url: LOBBY_GAME_URLS.FISHING,
    category: CATEGORY_GAME_SLUG.BANCA,
    icon: 'icon-ban-ca',
    label: 'Hot'
  },
  {
    title: 'Lô Đề',
    url: LOBBY_GAME_URLS.LODE,
    category: CATEGORY_GAME_SLUG.LODE,
    icon: 'icon-lo-de',
    label: ''
  },
  {
    title: 'Quay Số',
    url: LOBBY_GAME_URLS.LOTTERY,
    category: CATEGORY_GAME_SLUG.QUAY_SO,
    icon: 'icon-quay-so',
    label: ''
  },
  {
    title: 'Game Khác',
    url: LOBBY_GAME_URLS.OTHERS,
    category: CATEGORY_GAME_SLUG.OTHERS,
    icon: 'icon-game-khac',
    label: ''
  }
]

export const menuBannerGamesMobile = [
  {
    title: 'LIVE CASINO',
    url: LIVE_CASINO_PATH,
    category: '',
    icon: 'casino',
    label: 'Hot',
    text: 'Cược To - Thắng Lớn'
  },
  {
    title: 'NỔ HŨ',
    url: LOBBY_GAME_URLS.NO_HU,
    category: CATEGORY_GAME_SLUG.NOHU,
    icon: 'no-hu',
    label: 'Hot',
    text: ''
  }
]
